import React, { useCallback, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import UsersView from "./components/UsersView/UsersView";
import SessionsView from "./components/SessionsView/SessionsView";
import InvitesView from "./components/InvitesView/InvitesView";
import SubscriptionsView from "./components/SubscriptionsView/SubscriptionsView";
import VideosView from "./components/VideosView/VideosView";
import { useAdminSearchStore } from "./store/adminSearchStore";
import { useUserData } from "../../hooks/useUserData";
import Select from "../../components/shared/Select/Select";

export default function AdminUserSearchPage() {
  const history = useHistory();
  const { userData, isLoading: userDataLoading } = useUserData();

  useEffect(() => {
    if (userDataLoading) return;
    if (userData?.role !== "admin") {
      history.replace("/dashboard");
    }
  }, [userData, userDataLoading, history]);

  const {
    currentTable,
    setCurrentTable,
    resetUsersState,
    resetSessionsState,
    resetInvitesState,
    resetSubscriptionsState,
    resetVideosState,
  } = useAdminSearchStore();

  const tableOptions = useMemo(
    () => [
      { value: "users", text: "Users" },
      { value: "subscriptions", text: "Subscriptions" },
      { value: "invites", text: "Invites" },
      { value: "sessions", text: "Sessions" },
      { value: "videos", text: "Videos" },
    ],
    []
  );

  const currentTableLabel = useMemo(
    () =>
      tableOptions.find((opt) => opt.value === currentTable)?.text || "Users",
    [tableOptions, currentTable]
  );

  const renderTableView = () => {
    switch (currentTable) {
      case "sessions":
        return <SessionsView />;
      case "invites":
        return <InvitesView />;
      case "subscriptions":
        return <SubscriptionsView />;
      case "videos":
        return <VideosView />;
      case "users":
      default:
        return <UsersView />;
    }
  };

  if (userDataLoading || userData?.role !== "admin") {
    return null;
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-8">
      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center">
        <h1 className="text-3xl font-semibold tracking-tight text-gray900">
          Admin · {currentTableLabel}
        </h1>
        <Select
          btnInitialColor="white/gray300"
          btnSelectedColor="primary50"
          buttonProps={{
            size: "md",
            rounded: "lg",
          }}
          className="w-fit"
          menuClassName="w-64"
          onChange={(val) => setCurrentTable(val)}
          options={tableOptions}
          placeholder="Choose table"
          value={currentTable}
        />
      </div>
      {renderTableView()}
    </div>
  );
}
